import Vue from 'vue'
import 'altcha'

// Tell Vue to ignore the altcha-widget custom element (it's a web component)
Vue.config.ignoredElements = [...Vue.config.ignoredElements, 'altcha-widget']
